var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIconNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18146 0C3.22384 0 0 3.22274 0 7.17903C0 11.1353 3.22384 14.3643 7.18146 14.3643C8.87188 14.3643 10.4265 13.7721 11.6553 12.7888L14.6466 15.7776C14.7976 15.9223 14.9992 16.0021 15.2083 16C15.4174 15.9978 15.6174 15.9139 15.7653 15.7662C15.9133 15.6185 15.9975 15.4188 15.9999 15.2097C16.0024 15.0007 15.9228 14.799 15.7783 14.6479L12.787 11.6576C13.7714 10.4274 14.3645 8.87082 14.3645 7.17903C14.3645 3.22274 11.1391 0 7.18146 0ZM7.18146 1.59571C10.2764 1.59571 12.7667 4.08513 12.7667 7.17903C12.7667 10.2729 10.2764 12.7686 7.18146 12.7686C4.08651 12.7686 1.59623 10.2729 1.59623 7.17903C1.59623 4.08513 4.08651 1.59571 7.18146 1.59571Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconNew);
export default __webpack_public_path__ + "static/media/searchIconNew.621d948cf90b0763f47649bd659a2b3a.svg";
export { ForwardRef as ReactComponent };